export const themeOptions = {
  typography: {
    h1: {
      fontWeight: 600,
      fontSize: 40,
      fontFamily: "'Open Sans', sans-serif",
      "@media(max-width:767px)": {
        fontSize: "30px !important",
        lineHeight: "44px",
      },
    },
    h2: {
      fontWeight: 600,
      fontSize: 30,
      fontFamily: "'Open Sans', sans-serif",
      "@media(max-width:767px)": {
        fontSize: "24px !important",
      },
    },
    h3: {
      fontWeight: 600,
      fontSize: 22,
      fontFamily: "'Open Sans', sans-serif",
      "@media(max-width:767px)": {
        fontSize: "20px !important",
      },
    },
    h4: {
      fontWeight: 400,
      fontSize: 20,
      fontFamily: "'Open Sans', sans-serif",
      lineHeight: "30px",
      "@media(max-width:767px)": {
        fontSize: "18px !important",
      },
    },
    h5: {
      fontWeight: 400,
      fontSize: 18,
      fontFamily: "'Open Sans', sans-serif",

      "@media(max-width:767px)": {
        fontSize: "16px !important",
      },
    },
    h6: {
      fontWeight: 400,
      fontSize: 16,
      fontFamily: "'Open Sans', sans-serif",

      "@media(max-width:767px)": {
        fontSize: "14px !important",
      },
    },
    overline: {
      fontWeight: 500,
      fontFamily: "'Open Sans', sans-serif",
    },
    button: {
      textTransform: "capitalize",
      borderRadius: 27,
      fontFamily: "'Open Sans', sans-serif",
    },
    body1: {
      fontSize: 16,
      fontWeight: 300,
      lineHeight: "30px",
      fontFamily: "'Open Sans', sans-serif",

      "@media(max-width:767px)": {
        fontSize: "14px !important",
      },
    },
    body2: {
      fontSize: 14,
      fontWeight: 300,
      fontFamily: "'Open Sans', sans-serif",
      lineHeight: "30px",
      "@media(max-width:767px)": {
        fontSize: "12px !important",
      },
    },
    subtitle1: {
      fontSize: 12,
      fontWeight: 300,
      lineHeight: "30px",
      fontFamily: "'Open Sans', sans-serif",
    },
  },
};
